import { useState } from 'react';
import { Menu } from 'antd';
import './AccountPage.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from './AccountPage.lang.json';
import ChangePersonalInfo from '../components/AccountSettings/ChangePersonalInfo';
import EmployersManager from '../components/EmployersManager';

const AdminAccountPage = () => {
  const { lang } = useLanguage(translations);
  const [selectedKey, setSelectedKey] = useState(null);
  const items = [
    {
      key: 'adminDashboard',
      label: lang('adminDashboard'),
    },
    {
      key: 'accountSettings',
      label: lang('accountSettings'),
      children: [
        {
          key: 'changePersonalInfo',
          label: lang('changePersonalInfo'),
        },
      ],
    },
    {
      key: 'contactSupport',
      label: lang('contactSupport'),
    },
    {
      type: 'divider',
    },
    {
      key: 'recommendCrecer',
      label: lang('recommendCrecer'),
    },
  ];
  const onMenuClick = (e) => {
    setSelectedKey(e.key);
  };

  const displaySelectedItem = () => {
    switch (selectedKey) {
      case 'changePersonalInfo':
        return <ChangePersonalInfo />;
      // case 'contactSupport':
      // return <ContactSupport />;
      // case 'recommendCrecer':
      // return <RecommendCrecer />;
      case 'adminDashboard':
      default:
        return <EmployersManager />;
    }
  };

  return (
    <main className="main-container">
      <Menu onClick={onMenuClick} className="sidebar-menu" mode="inline" items={items} selectedKeys={[selectedKey]} />
      <div className="content-area">{displaySelectedItem()}</div>
    </main>
  );
};

export default AdminAccountPage;
